import reducer from "./reducer";
import { createStore } from "redux";

const store = createStore(reducer);
export const dispatch = store.dispatch.bind(store);
export default store;
